import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../../App";

const emptyRow = { conference: "LIRSS", day: "November 25, 2026", start: "", end: "", session: "", title: "", speaker: "", type: "Talk", order: 0 };

const ProgrammeEditor = () => {
  const [sessions, setSessions] = useState([]);
  const [newRow, setNewRow] = useState(emptyRow);
  const [loading, setLoading] = useState(true);

  const authHeaders = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("adminToken")}` } });

  const load = async () => {
    setLoading(true);
    const res = await axios.get(`${API}/programme/`, authHeaders());
    setSessions(res.data.data);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleFieldChange = (id, field, value) => {
    setSessions(prev => prev.map(s => s._id === id ? { ...s, [field]: value } : s));
  };

  const handleSave = async (row) => {
    const { _id, ...rest } = row;
    await axios.put(`${API}/programme/${_id}`, rest, authHeaders());
    load();
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this session row?")) return;
    await axios.delete(`${API}/programme/${id}`, authHeaders());
    load();
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    await axios.post(`${API}/programme/`, newRow, authHeaders());
    setNewRow(emptyRow);
    load();
  };

  if (loading) return <div className="text-slate-400 p-4">Loading programme...</div>;

  return (
    <div className="bg-slate-800/60 rounded-xl border border-slate-700 p-6" data-testid="programme-editor">
      <h2 className="text-lg font-semibold text-white mb-4">Programme ({sessions.length} sessions)</h2>
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="programme-table">
          <thead>
            <tr className="text-slate-400 text-xs uppercase">
              <th className="text-left px-2 py-1">Conf</th>
              <th className="text-left px-2 py-1">Day</th>
              <th className="text-left px-2 py-1">Start</th>
              <th className="text-left px-2 py-1">End</th>
              <th className="text-left px-2 py-1">Title</th>
              <th className="text-left px-2 py-1">Speaker</th>
              <th className="text-left px-2 py-1"></th>
            </tr>
          </thead>
          <tbody>
            {sessions.map((row) => (
              <tr key={row._id} className="border-t border-slate-700" data-testid={`programme-row-${row._id}`}>
                <td className="px-2 py-1 text-slate-300">{row.conference}</td>
                <td className="px-2 py-1 text-slate-300 whitespace-nowrap">{row.day}</td>
                <td className="px-1 py-1"><input value={row.start} onChange={(e) => handleFieldChange(row._id, "start", e.target.value)} className="w-16 bg-slate-700 rounded px-1 text-white text-xs" /></td>
                <td className="px-1 py-1"><input value={row.end} onChange={(e) => handleFieldChange(row._id, "end", e.target.value)} className="w-16 bg-slate-700 rounded px-1 text-white text-xs" /></td>
                <td className="px-1 py-1"><input value={row.title} onChange={(e) => handleFieldChange(row._id, "title", e.target.value)} className="w-56 bg-slate-700 rounded px-1 text-white text-xs" /></td>
                <td className="px-1 py-1"><input value={row.speaker} onChange={(e) => handleFieldChange(row._id, "speaker", e.target.value)} className="w-40 bg-slate-700 rounded px-1 text-white text-xs" /></td>
                <td className="px-1 py-1 whitespace-nowrap">
                  <button onClick={() => handleSave(row)} className="text-emerald-400 text-xs mr-2" data-testid={`programme-save-${row._id}`}>Save</button>
                  <button onClick={() => handleDelete(row._id)} className="text-red-400 text-xs" data-testid={`programme-delete-${row._id}`}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <form onSubmit={handleAdd} className="mt-4 flex flex-wrap gap-2 items-center" data-testid="programme-add-form">
        <select value={newRow.conference} onChange={(e) => setNewRow({ ...newRow, conference: e.target.value })} className="bg-slate-700 rounded px-2 py-1 text-white text-xs">
          <option>LIRSS</option><option>LIBSS</option>
        </select>
        <input placeholder="Day (e.g. November 25, 2026)" value={newRow.day} onChange={(e) => setNewRow({ ...newRow, day: e.target.value })} className="bg-slate-700 rounded px-2 py-1 text-white text-xs w-48" />
        <input placeholder="Start" value={newRow.start} onChange={(e) => setNewRow({ ...newRow, start: e.target.value })} className="bg-slate-700 rounded px-2 py-1 text-white text-xs w-16" />
        <input placeholder="End" value={newRow.end} onChange={(e) => setNewRow({ ...newRow, end: e.target.value })} className="bg-slate-700 rounded px-2 py-1 text-white text-xs w-16" />
        <input placeholder="Title" value={newRow.title} onChange={(e) => setNewRow({ ...newRow, title: e.target.value })} className="bg-slate-700 rounded px-2 py-1 text-white text-xs w-56" />
        <input placeholder="Speaker" value={newRow.speaker} onChange={(e) => setNewRow({ ...newRow, speaker: e.target.value })} className="bg-slate-700 rounded px-2 py-1 text-white text-xs w-40" />
        <button type="submit" className="bg-emerald-600 hover:bg-emerald-700 text-white text-xs px-3 py-1.5 rounded" data-testid="programme-add-btn">Add Row</button>
      </form>
    </div>
  );
};

export default ProgrammeEditor;
